import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XMarkIcon, RocketLaunchIcon, SparklesIcon } from '@heroicons/react/24/outline';

const PremiumUpgradeModal = ({ isOpen, onClose, title = "Unlock Premium Features", message = "Upgrade your subscription to continue learning without limits." }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#1E1B4B]/80 backdrop-blur-md animate-in fade-in duration-300">
            <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden border border-primary/10 transform transition-all scale-100">
                {/* Header Decoration */}
                <div className="h-2 bg-gradient-to-r from-primary via-secondary to-accent"></div>
                
                <button 
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 text-gray-400 hover:text-primary hover:bg-primary/5 rounded-full transition-colors"
                >
                    <XMarkIcon className="w-6 h-6" />
                </button>

                <div className="p-8 text-center">
                    <div className="mx-auto w-16 h-16 bg-primary/5 rounded-2xl flex items-center justify-center mb-6">
                        <SparklesIcon className="w-10 h-10 text-primary" />
                    </div>

                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        {title}
                    </h3>
                    
                    <p className="text-gray-600 mb-8 leading-relaxed">
                        {message}
                    </p>

                    <div className="space-y-3">
                        <button
                            onClick={() => {
                                navigate('/subscription-plans');
                                onClose();
                            }}
                            className="w-full py-4 px-6 bg-gradient-to-r from-primary to-accent hover:from-secondary hover:to-primary text-white font-semibold rounded-xl shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2"
                        >
                            <RocketLaunchIcon className="w-5 h-5" />
                            View Plans & Upgrade Now
                        </button>
                        
                        <button
                            onClick={onClose}
                            className="w-full py-3 px-6 text-gray-500 hover:text-primary font-medium transition-colors"
                        >
                            Maybe Later
                        </button>
                    </div>
                </div>

                {/* Footer Info */}
                <div className="px-8 py-4 bg-primary/5 border-t border-primary/5 text-center">
                    <p className="text-xs text-primary/70">
                        Join 10,000+ professionals mastering new skills every day.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PremiumUpgradeModal;
